import React from "react";

const CartIconBlack = (props = "") => {
  return (
    <svg
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.5 13.5C5.77614 13.5 6 13.2761 6 13C6 12.7239 5.77614 12.5 5.5 12.5C5.22386 12.5 5 12.7239 5 13C5 13.2761 5.22386 13.5 5.5 13.5Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 13.5C12.7761 13.5 13 13.2761 13 13C13 12.7239 12.7761 12.5 12.5 12.5C12.2239 12.5 12 12.7239 12 13C12 13.2761 12.2239 13.5 12.5 13.5Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 2.5H3.5L5 11H13"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 9H12.795C12.8528 9.00004 12.9089 8.98004 12.9536 8.9434C12.9983 8.90676 13.029 8.85576 13.0403 8.79906L13.9403 4.29906C13.9476 4.26278 13.9467 4.22533 13.9377 4.18943C13.9288 4.15352 13.9119 4.12006 13.8885 4.09145C13.865 4.06284 13.8355 4.03979 13.802 4.02398C13.7686 4.00816 13.732 3.99997 13.695 4H4"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CartIconBlack;
